"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Le detail technique reste cote serveur : on n'expose jamais
    // de trace d'execution au visiteur.
    console.error(error.digest ?? error.message);
  }, [error]);

  return (
    <div className="flex min-h-screen items-center justify-center px-5">
      <div className="max-w-md text-center">
        <h1 className="text-2xl font-bold text-ink-900">
          Une erreur est survenue
        </h1>
        <p className="mt-3 text-ink-500">
          Le problème a été enregistré. Vous pouvez réessayer ; si cela
          persiste, écrivez-nous.
        </p>
        <button type="button" onClick={reset} className="btn btn-primary mt-6">
          Réessayer
        </button>
      </div>
    </div>
  );
}
